import $ from 'jquery';

$(function () {
  var setupGroupsTree = function () {
    var includeDeactivated = false;
    var $root = $('#js-groups-tree-root');

    if (!$root.length) {
      return;
    }

    function bindCheckBoxes() {
      $root.on('click', '.js-groups-checkbox', function (e) {
        e.stopPropagation();
      });
      $root.on('change', '.js-groups-checkbox', updateEmployeeIds);
    }

    function updateEmployeeIds() {
      var query;
      if (this.checked) {
        $(this).addClass('added');
      } else {
        $(this).removeClass('added');
      }

      // assemble new query set by node IDs
      query = $('.added', $root)
        .closest('.node')
        .map(function () {
          return $(this).data('node-id');
        });
      $('#reporting_group_ids').val(query.toArray().join());
    }

    // options links
    function selectAll() {
      $root.find('.js-groups-checkbox').prop('checked', true).trigger('change');
    }

    function deselectAll() {
      $root
        .find('.js-groups-checkbox')
        .prop('checked', false)
        .trigger('change');
    }

    function bindMassOptions() {
      $('.js-select-all.groups').click(selectAll);
      $('.js-deselect-all.groups').click(deselectAll);
    }

    // 'only' links
    function bindOnlyLinks() {
      $root.on('click', '.only-link', function (e) {
        e.stopPropagation();

        $('.js-groups-checkbox.added')
          .prop('checked', false)
          .removeClass('added');
        $(this)
          .siblings('.js-groups-checkbox')
          .prop('checked', true)
          .addClass('added')
          .trigger('change');
      });
    }

    function bindNodeSelectors() {
      bindCheckBoxes();
      bindOnlyLinks();
      bindMassOptions();
    }

    // search to filter
    function hideAll() {
      $(
        '#js-groups-tree-root .node, #js-groups-tree-root .js-node-content',
      ).addClass('hidden');
    }

    function showAll() {
      var nodeSelector = includeDeactivated
        ? '.node'
        : '.node:not(.js-deactivated-employee)';
      $('#js-groups-tree-root ' + nodeSelector).removeClass('hidden');
      $('#js-groups-tree-root .js-node-content').removeClass('hidden');
    }

    function resetList() {
      showAll();
      unhighlight();
      $('.match').removeClass('match');
      $('#js-groups-tree-search .action .fa-search').removeClass('hidden');
      $('#js-groups-tree-search .action .fa-times').addClass('hidden');
    }

    function highlightMatches($matches, query) {
      var term = query.replace(/(\s+)/, '(<[^>]+>)*$1(<[^>]+>)*');
      var pattern = new RegExp('(' + term + ')', 'i');

      $matches.each(function () {
        var srcStr = this.innerHTML;
        srcStr = srcStr.replace(pattern, '<mark>$1</mark>');
        srcStr = srcStr.replace(
          /(<mark>[^<>]*)((<[^>]+>)+)([^<>]*<\/mark>)/,
          '$1</mark>$2<mark>$4',
        );

        this.innerHTML = srcStr;
      });
    }

    function unhighlight() {
      $('mark').contents().unwrap();
    }

    function onlyShowMatches($matches, query) {
      // make them all visible (and their parents as needed)
      hideAll();
      unhighlight();

      if ($matches.length) {
        $matches
          .parents()
          .removeClass('hidden')
          .children('.js-node-content')
          .removeClass('hidden');
        $matches
          .parents('.node')
          .children('.js-node-content')
          .children('i')
          .removeClass('fa-folder')
          .addClass('fa-folder-open');
        $matches
          .parents('.node')
          .children('.js-node-content')
          .addClass('match');
        // if match is parent, show all children
        highlightMatches($matches, query);
      }
    }

    function debounce(func, delay, { leading } = {}) {
      let timerId;

      return function (...args) {
        const ctx = this;

        if (!timerId && leading) {
          func.apply(ctx, args);
        }
        clearTimeout(timerId);

        timerId = setTimeout(() => func.apply(ctx, args), delay);
      };
    }

    function bindSearch() {
      var $allNames = $('#js-groups-tree-root .name');
      var $activeNames = $allNames.not('.deactivated');
      var $input = $('#js-groups-tree-search input');
      var $startSearchBtn = $('#js-groups-tree-search .action .fa-search');
      var $clearSearchBtn = $('#js-groups-tree-search .action .fa-times');

      var searchFunction = function () {
        var $matches;
        var $namesToFilter;
        var query = $input.val().toLowerCase();

        if (!query) {
          $startSearchBtn.removeClass('hidden');
          $clearSearchBtn.addClass('hidden');

          resetList();
        } else {
          $startSearchBtn.addClass('hidden');
          $clearSearchBtn.removeClass('hidden');

          $namesToFilter = includeDeactivated ? $allNames : $activeNames;
          $matches = $namesToFilter.filter(function () {
            if (this.innerText.toLowerCase().indexOf(query) !== -1) {
              return true;
            } else {
              return false;
            }
          });

          onlyShowMatches($matches, query);
        }
      };

      $input.keyup(
        debounce(function () {
          if (this.value.length >= 2) {
            searchFunction();
          }
        }, 500),
      );

      $input.keypress(function (e) {
        var enterKeyCode = 13;
        if (e.which == enterKeyCode) {
          searchFunction();
          return false;
        }
      });

      $clearSearchBtn.click(function () {
        $input.val('').focus();
        resetList();
      });

      $startSearchBtn.click(searchFunction);
    }

    function bindDeactivated() {
      var $checkbox = $('.js-filter-deactivated :checkbox');
      $checkbox.change(function () {
        var $deactivated = $('.js-deactivated-employee');
        if ($checkbox.is(':checked')) {
          includeDeactivated = true;
          $deactivated.removeClass('hidden');
        } else {
          includeDeactivated = false;
          $('.js-deactivated-employee :checkbox')
            .prop('checked', false)
            .removeClass('added');
          $deactivated.addClass('hidden');
          updateEmployeeIds();
        }
      });
    }

    function bindClearFilters() {
      $('.js-clear-filters').click(deselectAll);
    }

    bindNodeSelectors();
    bindDeactivated();
    bindSearch();
    bindClearFilters();

    $root.removeClass('hidden');

    setupGroupsTree.clearSelection = deselectAll;
  };

  setupGroupsTree();
  $(document).on('leaderboard-page-update', setupGroupsTree);

  $('a[data-toggle="pill"]').on('shown.bs.tab', function (e) {
    if ($(e.target).attr('href') === '#teams-leaderboard') {
      setupGroupsTree.clearSelection();
    }
  });
});
